import { getEdificiosListadoPublicoVista, calcularResumenRedComercial } from "../../utils";

// Fase B, precarga (2026-09-26): ÚNICO lugar donde se declaran las consultas que usan las láminas
// del mediakit (10.1) — MediakitDataProvider las dispara TODAS en paralelo al montar el visor.
// Cada lámina futura con datos vivos suma su entrada acá; nunca dispara su propio fetch (ver
// laminas/Lamina03Crecimiento.js, que solo LEE del proveedor).
// Lee la VISTA `edificios_publico` (espejo público de getEdificiosListadoPublico, A3 paso 3): esta ruta
// es pública (sin sesión) y la tabla real `edificios` deja de ser legible por anon.
export const MEDIAKIT_DATA_SOURCES = {
  resumenRed: async () => {
    const edificios = await getEdificiosListadoPublicoVista({ pais: "Chile" });
    return calcularResumenRedComercial(edificios);
  },
};
